import Redux from 'redux'
import * as App from '../../app'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const FormActions = Form.createActionsMap<Types.FormFields>(Constants.MODAL_SCHEDULE)
export const FormConstants = Form.createConstantsMap(Constants.MODAL_SCHEDULE)

export type ResetModal = Modal.Reset
export const resetModal: ResetModal = Modal.resetModal(Constants.MODAL_SCHEDULE)

export type ToggleModal = Modal.Toggle

export interface EditAction extends Redux.Action {
  schedule: Types.Schedule,
}

type EditModalAction = (schedule: Types.Schedule) => Form.EnterAction<Types.FormFields>
export const onEdit: EditModalAction = (schedule: Types.Schedule) => FormActions[Form.ENTER](schedule)

export type OpenModalAction = () => Form.EnterAction<Types.FormFields>
export const onOpen: OpenModalAction = () =>
  FormActions[Form.ENTER](Constants.emptyModalSchedule)
export const toggleModal: ToggleModal = Modal.toggleModal(Constants.MODAL_SCHEDULE)

export type SaveModalAction = () => Form.SaveAction<Types.FormFields>
export const submit: SaveModalAction = FormActions[Form.SAVE]

export type FetchActionCreator = (communityIdentifier: App.SelectedCommunity) => Request.RequestAction
export const fetch: FetchActionCreator =
  (communityIdentifier: string) =>
    Request.requestActionCreator(Constants.FETCH_SCHEDULES)({
      method: 'GET',
      url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}?version=${Constants.FETCH_VERSION_FORMAT}`,
    })

export type CreateActionCreator =
  (communityIdentifier: App.SelectedCommunity, data: Form.Fields<Types.FormFields>) => Request.RequestAction

export const create: CreateActionCreator =
  (communityIdentifier: App.SelectedCommunity, data: Form.Fields<Types.FormFields>) =>
  Request.requestActionCreator(Constants.ADD_SCHEDULE)({
    method: 'POST',
    payload: data,
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}`,
  })

export type UpdateActionCreator =
  (community: App.SelectedCommunity, stateChange: IsActive.StateChange) => Request.RequestAction

export const update: UpdateActionCreator =
  (communityIdentifier: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_SCHEDULE_INLINE)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Constants.SERVER_RESOURCE}/${communityIdentifier}/${stateChange.id}`,
  })



// WEBPACK FOOTER //
// ./src/pages/schedules/actions.ts